import React, { PropTypes, Component } from 'react'
import WeekControl from 'components/weekControl'
import TimeSheet from 'components/timesheet'
import misc from 'utils/misc'
import styles from 'styles'
import co from 'co'
import classNames from 'classnames'
import { aProjects, aTasks, aRecords, aUsers, aWeekReports, aDates } from 'utils/aUtils'

export default class WeekReportPage extends Component {

  static propTypes = {
    me: PropTypes.object,
  };

  constructor (props, context) {
    super(props, context)
    this.onWeekChange = ::this.onWeekChange
    this.onWeekReportChange = ::this.onWeekReportChange
    this.updateTimesheetState = ::this.updateTimesheetState
    this.filterWeekReports = ::this.filterWeekReports
    this.toggleUnconfirm = ::this.toggleUnconfirm
  }

  // this copy from timesheetPage, need to rewrite later
  state = {
    userId: 0,
    thisMonday: { year: 2016, month: 2, date: 1 },
    weekReports: [],
    records: [],
    users: [],
    projects: [],
    tasks: [],
    dates: [],
    weekReport: {},
    projectShow: [],
    taskShow: {},
    onlyUnconfirm: false,
  };

  componentWillMount () {
    const _this = this
    const me = this.props.me
    co(function *() {
      const monday = misc.getMondayByMs(new Date)
      const { users, projects, tasks, dates, weekReports } = yield {
        users: aUsers.find(),
        projects: aProjects.find(),
        tasks: aTasks.find(),
        dates: aDates.find(),
        weekReports: aWeekReports.find('', monday),
      }
      let weekReport = {}
      let userId = 0
      let records = []
      const filteredWeekReports = _this.filterWeekReports(weekReports, me, projects)
      if (filteredWeekReports.length > 0) {
        weekReport = filteredWeekReports[0]
        userId = weekReport.userId
        records = yield aRecords.findWeek(userId, monday)
      }
      _this.setState({
        userId,
        records,
        users,
        projects,
        tasks,
        dates,
        weekReport,
        thisMonday: monday,
        weekReports: filteredWeekReports,
      })
    }).catch(misc.onError)
  }

  onWeekChange (shift) {
    const userId = this.state.userId
    const monday = misc.getShiftedMonday(this.state.thisMonday, shift)
    this.updateTimesheetState(userId, monday)
  }

  onWeekReportChange (action, projectId, userId) {
    let weekReport
    let weekReports
    const me = this.props.me
    const monday = this.state.thisMonday
    if (action === 'accept' || action === 'reject') {
      weekReport = misc.deepCopy(this.state.weekReport)
      weekReport.reviews = weekReport.reviews.map(review => {
        const newReview = misc.deepCopy(review)
        if (review.projectId === projectId) {
          newReview.state = action
          newReview.userId = userId
        }
        return newReview
      })
    }

    if (action === 'confirm') {
      weekReport = misc.deepCopy(this.state.weekReport)
      weekReport.isDone = true
    }
    if (action === 'revert') {
      weekReport = misc.deepCopy(this.state.weekReport)
      weekReport.isDone = false
    }

    const _this = this
    co(function *() {
      yield aWeekReports.update(weekReport)
      // TODO SPEED UP
      weekReports = yield aWeekReports.find('', monday)
      weekReports = _this.filterWeekReports(weekReports, me, _this.state.projects)
      _this.setState({ weekReport, weekReports })
    }).catch(misc.onError)
  }

  filterWeekReports (weekReports, me, projects) {
    const projectLeaderIds = misc.getDict(projects, 'usersId')
    const result = weekReports.filter(report => (
      me.role === 'admin' || me.role === 'manager' ||
      !report.reviews.every(review => me._id !== projectLeaderIds[review.projectId])
    ))

    return this.state.onlyUnconfirm ? result.filter(re => !re.isDone) : result
  }

  toggleUnconfirm () {
    this.setState({ onlyUnconfirm: !this.state.onlyUnconfirm })
    const userId = this.state.userId
    const monday = this.state.thisMonday
    this.updateTimesheetState(userId, monday)
  }

  updateTimesheetState (_userId, monday) {
    const _this = this
    const me = this.props.me
    co(function *() {
      let records = []
      let weekReport = {}
      let weekReports = []
      let userId = _userId
      weekReports = yield aWeekReports.find('', monday)
      weekReports = _this.filterWeekReports(weekReports, me, _this.state.projects)
      if (weekReports.length > 0) {
        if (!userId) {
          weekReport = weekReports[0]
          userId = weekReport.userId
        } else {
          const userReport = weekReports.filter(r => r.userId === userId)
          if (userReport.length > 0) {
            weekReport = userReport[0]
          } else {
            userId = weekReports[0].userId
          }
        }
        if (userId) {
          records = yield aRecords.findWeek(userId, monday)
        }
      }
      _this.setState({
        userId,
        records,
        weekReport,
        weekReports,
        thisMonday: monday,
      })
    }).catch(misc.onError)
  }

  render () {
    const { thisMonday, weekReport, weekReports, users, onlyUnconfirm } = this.state
    const me = this.props.me
    const userNames = misc.getDict(users, 'name')
    const genOnUserReportClick = (userId) => () => { this.updateTimesheetState(userId, thisMonday) }
    const rawData = this.state
    rawData.me = me

    return (
      <div className={styles.weekReportPage}>
        <div className={styles.reportPageHeader}>
          <div className={styles.reportPageTitle}>
            週報審核人：{me && me.name}
            <span className={styles.submit}>
              <input
                type="button"
                onClick={this.toggleUnconfirm}
                value={onlyUnconfirm ? '顯示全部' : '顯示未確認'}
              />
            </span>
          </div>
          <div className={styles.reportWeekControl}>
            <WeekControl
              thisMonday={thisMonday}
              onWeekChange={this.onWeekChange}
            />
          </div>
        </div>
        <div className={styles.sideBar}>
          {weekReports.map((r, i) =>
            <div
              key={i}
              className={classNames(
              styles.sideBarItem,
              { [styles.selected]: r.userId === weekReport.userId })}
              onClick={genOnUserReportClick(r.userId)}
            >
              {userNames[r.userId]}
            </div>
          )}
          {weekReports.length === 0 ?
            <div className={styles.sideBarItem}>尚無人送週報</div> : null}
        </div>
        {misc.isEmpty(weekReport) ? null :
          <div className={styles.timesheetReviewArea}>
            <TimeSheet
              rawData={rawData}
              onWeekReportChange={this.onWeekReportChange}
              reviewMode
            />
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/weekReportPage.jsx